"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlLabel = _interopRequireDefault(require("../control-label"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const propNames = ['id', 'value', 'onChange', 'label', 'noAuto', 'optional', 'aside', 'validationError', 'themeControlTextarea', 'themeControlWrapper', 'themeLabel', // Passed when used with the Form component
'initialValue', 'validator'];

class ControlTextarea extends _react.default.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onChange", e => {
      return this.props.onChange(e.target.value, this.props.id);
    });
  }

  render() {
    const extraProps = (0, _omit.default)(this.props, propNames);
    const {
      id,
      value,
      label,
      optional,
      aside,
      validationError,
      noAuto,
      themeControlTextarea,
      themeControlWrapper,
      themeLabel
    } = this.props;
    const textareaProps = {
      id,
      name: id,
      onChange: this.onChange,
      value,
      className: themeControlTextarea,
      'aria-required': optional ? false : true,
      'data-test': `${id}-textarea`
    };

    if (noAuto) {
      textareaProps.autoCapitalize = 'none';
      textareaProps.autoCorrect = 'off';
      textareaProps.spellCheck = false;
    }

    if (validationError) {
      textareaProps['aria-invalid'] = true;
    }

    return /*#__PURE__*/_react.default.createElement(_controlWrapper.default, {
      themeControlWrapper: themeControlWrapper,
      id: id,
      validationError: validationError
    }, label && /*#__PURE__*/_react.default.createElement(_controlLabel.default, {
      text: label,
      id: id,
      aside: aside,
      optional: optional,
      themeLabel: themeLabel
    }), /*#__PURE__*/_react.default.createElement("textarea", _extends({}, textareaProps, extraProps)));
  }

}

exports.default = ControlTextarea;

_defineProperty(ControlTextarea, "propTypes", {
  /** Unique id for this control. Required if you want a `label`. */
  id: _propTypes.default.string,

  /** The control's value. */
  value: _propTypes.default.string,

  /**
   * Invoked when the control's value changes.
   * Passed two arguments: the new value, and the `id` prop.
   */
  onChange: _propTypes.default.func.isRequired,

  /** Label for the control. */
  label: _propTypes.default.string,

  /** If `true`, autocorrect and spelling suggestions will be disabled. */
  noAuto: _propTypes.default.bool,

  /** If `true`, the text `(optional)` is appended to the label element. */
  optional: _propTypes.default.bool,

  /** Additional content inserted alongside the label element. */
  aside: _propTypes.default.node,

  /** A validation error to display beneath the control. */
  validationError: _propTypes.default.node,

  /** Classes to apply to the textarea element. */
  themeControlTextarea: _propTypes.default.string,

  /** Classes to apply to the control wrapper. */
  themeControlWrapper: _propTypes.default.string,

  /** Classes to apply to the label element. */
  themeLabel: _propTypes.default.string
});

_defineProperty(ControlTextarea, "defaultProps", {
  value: '',
  optional: false,
  noAuto: false,
  themeControlTextarea: 'textarea hmin120'
});